import { TVendorStatus } from '../types/vendor-types';

export const VENDOR_STATUS_CONFIG: Record<
  TVendorStatus,
  { label: string; backgroundColor: string; textColor: string }
> = {
  pending: {
    label: 'Pending',
    backgroundColor: '#fff3cd',
    textColor: '#856404',
  },
  applied: {
    label: 'Applied',
    backgroundColor: '#d4edda',
    textColor: '#155724',
  },
  rejected: {
    label: 'Rejected',
    backgroundColor: '#f8d7da',
    textColor: '#721c24',
  },
};

export const DOC_REVIEWED_OPTIONS = {
  true: 'Reviewed',
  false: 'Not Reviewed',
  all: 'All',
} as const;
